import React from 'react';
import Grid from '@mui/material/Grid2';
import { SnackbarProvider, useSnackbar } from 'notistack';
import AppAnimate from "../../../../components/AppAnimate";
import BannersManager from "./BannersManager";
import {useTranslation} from "react-i18next";
import AppCard from "../../../../components/layout/components/AppCard";
import Title from "../../../../components/elements/Title";
import {Divider} from "@mui/material";

const BannersPage = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('manageBanners')}>
            <Grid container spacing={2} justifyContent="center">
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{t('restaurants_top_banners')}</Title>
                    <BannersManager position="restaurants_top_banners" />
                </Grid>
                <Divider className="global-hr"/>
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{t('markets_top_banners')}</Title>
                    <BannersManager position="markets_top_banners" />
                </Grid>
                <Divider className="global-hr"/>
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{t('charities_top_banners')}</Title>
                    <BannersManager position="charities_top_banners" />
                </Grid>
            </Grid>
        </AppAnimate>
    );
};

export default BannersPage;
